import gql from "graphql-tag"

const ProductData = gql`
  fragment productDataFields on ProductData {
    cinemaMetadata {
      enabled
      locations
    }
    externalMetadata {
      apiCode
      denomination
      nativeID
      openValue
      reservable
    }
  }
`

const fragment = gql`
  fragment fullProduct on Product {
    data {
      ...productDataFields
    }
    date
    dateUnix
    locale
    name
    supplier
    type
    uuid
    active
    currency
    provider
    vat
    acqDiscount
  }
  ${ProductData}
`

export default fragment
